<div class="box">
	<slot></slot>
</div>

<style>
	.box {
	  width: 300px;
	  border: 1px solid #aaa;
	  border-radius: 1px;
	  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
	  background-color: #5dade2;
	  text-align: center;
	  margin: 0 0 1em 0;
	  color: white;
	}
</style>